import { useState } from "react";
import { useAsk } from "./lib/useAsk";
import { useLanding } from "./lib/useLanding";
import { SearchContext } from "src/search/useSearchContext";
import { SerializableTabs, Tabs, useTabs } from "./lib/useTabs";
import {
  ExploreDocument,
  SerializableDoc,
  useExploreDocument,
} from "./lib/useExploreDocument";
import {
  SerializableView,
  useContentView,
  ContentView,
} from "./lib/useContentView";

export enum ContextSource {
  Ask,
  Dashboard,
  ExplorePage,
}

export function useExplore(
  searchContext: SearchContext,
  initial: Partial<{
    view: SerializableView;
    doc: SerializableDoc;
    tabs: SerializableTabs;
  }>,
  source = ContextSource.Dashboard
): ExploreContext {
  const [first] = useState(initial);
  // Order is important, these have no internal dependencies
  const landing = useLanding(); // manages the active group and tag
  const tabs = useTabs(initial?.tabs);
  const view = useContentView(searchContext, first?.view);

  const doc = useExploreDocument(first?.doc, searchContext.params.serialized, {
    tabs,
    view,
    params: searchContext.params,
  });
  const ask = useAsk(searchContext, doc);
  return {
    ...searchContext,
    view,
    ask,
    doc,
    landing,
    tabs,
    source,
    title: doc.title || "",
  };
}

export type ExploreContext = SearchContext & {
  ask: ReturnType<typeof useAsk>;
  landing: ReturnType<typeof useLanding>;
  doc: ExploreDocument;
  view: ContentView;
  tabs: Tabs;
  source: ContextSource;
  title: string;
};
